import { isSchoolEmail } from '@share-a-cart/shared-utils';
import { useCurrentUser } from './queries';

export const useIsSchoolUser = (): boolean => {
  const { user } = useCurrentUser();

  if (!user || !user.email) {
    return false;
  }

  return isSchoolEmail(user.email);
};
